import { useTranslation } from 'react-i18next';
import { EntityDirectorySelectFilter } from '../shared/entityDirectory/EntityDirectorySelectFilter';

interface CustomerScopeFilterProps {
  value?: boolean;
  onChange: (value?: boolean) => void;
}

export function CustomerScopeFilter({
  value,
  onChange,
}: CustomerScopeFilterProps) {
  const { t } = useTranslation();

  return (
    <EntityDirectorySelectFilter
      options={[
        {
          label: t('brandsDirectory.myBrands'),
          value: true,
        },
      ]}
      placeholder={t('brandsDirectory.allBrands')}
      value={value}
      onChange={(selectedValue) => onChange(selectedValue ?? undefined)}
    />
  );
}
